import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";

export const Common = () => {
    document.title = "Ümumi anlayışlar";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ümumi anlayışlar", value: "/common", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <h2 className="my-4">Ümumi anlayışlar</h2>
                <div className="row g-4">
                    <div className="col-6">
                        <Link to={"print"}>Çap</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"save"}>Yadda saxla</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"close"}>Bağla</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"excel"}>Excel</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"closealert"}>Bağla xəbərdarlıq</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"shorts"}>Qısa keçidlər</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"fastsearch"}>Sürətli axtarış</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"filter"}>Filter</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"stockquantity"}>Anbar qalığı</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"owner"}>Cavabdeh</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"department"}>Şöbə</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"status"}>Keçirilib</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"related"}>Əlaqəli sənədlər</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"discount"}>Sənədlərdə endirim</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"modifications"}>Modifikasiyalar</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"terms"}>Terminlər</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
